<!-- results-table.component.html -->
<h1 mat-dialog-title>
    <strong>Modificar</strong> estado de la operación a <span>{{ actionLabel }}</span
    >?
</h1>
<div mat-dialog-content>
    <mat-form-field *ngIf="action == 'Rechazar'" class="select-list">
        <input placeholder="Motivo" matInput [(ngModel)]="motivo" />
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="doAction()">Aceptar</button>
    <button mat-button (click)="closeDialog()" mat-flat-button color="warn">
        {{ "Cancel" | translate }}
    </button>
</div>
